/**
 * Copyright (c) 2026, CheckPlus Limited
 */
import React from "react";
import { Redirect, Route } from "react-router-dom";
import { AuthConsumer } from "./AuthContext";
import RenderFullPageLoading from "./assets/component/RenderFullPageLoading.js";

function run(Component, rest) {
  function renderComponent(t, props, isOrgAuth, orgLogin, language) {
    const currentPath = props.location.pathname.substring(1).toUpperCase();
    const languageObj = t(currentPath, { returnObjects: true });

    return (
      <Component
        {...props}
        orgLogin={orgLogin}
        language={language}
        languageObj={languageObj}
        RenderFullPageLoading={RenderFullPageLoading}
      />
    );
  }

  return (
    <AuthConsumer>
      {({ t, isOrgAuth, orgLogin, language }) => (
        <Route
          render={(props) =>
            isOrgAuth ? (
              <Redirect to="/AccountOverview" />
            ) : (
              renderComponent(t, props, isOrgAuth, orgLogin, language)
            )
          }
          {...rest}
        />
      )}
    </AuthConsumer>
  );
}

const OrgLoginRoute = ({ component: Component, ...rest }) =>
  run(Component, rest);

export default OrgLoginRoute;
